import { useEffect, useRef } from 'react';

/**
 * Hook to get the previous value of a state or prop.
 * Pulled from https://usehooks.com/usePrevious/
 *
 * @param value - The current value to track
 * @returns The previous value
 */
const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export default usePrevious;
